<template>
    <a @click.stop.prevent="promptForRestart()" href="#!" data-title="Reset">
        <i class="far fa-undo"></i>
    </a>
</template>

<script type="text/ecmascript-6">
    export default {
        methods:{
            swalConfirm(prompt, yes_callback, no_callback){
                Swal.fire({
                    title: 'Are you sure?',
                    text: prompt,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                }).then((response) => {
                    if(response.isConfirmed){
                        yes_callback();
                    } else {
                        no_callback();
                    }
                });
            },
            promptForRestart(){
                this.swalConfirm('Do you want to discard your changes?', () => {
                    window.location.assign(window.location.href);
                });
            }
        }
    }
</script>
